import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function Success() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');
  const [orderDetails, setOrderDetails] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!orderId) {
      setError('No order ID found.');
      return;
    }

    fetch(`https://www.pay.quantech.pro/order-status/${orderId}`)
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch order status');
        return res.json();
      })
      .then(data => setOrderDetails(data))
      .catch(err => {
        console.error(err);
        setError('Could not fetch payment details.');
      });
  }, [orderId]);

  // Determine payment status text and color based on orderDetails.state
  const getPaymentStatusInfo = () => {
    if (!orderDetails) return { text: 'Processing', colorClass: 'processing' };
    
    switch(orderDetails.state) {
      case 'COMPLETED':
        return { text: 'Successful', colorClass: 'successful' };
      case 'FAILED':
        return { text: 'Failed', colorClass: 'failed' };
      case 'PENDING':
        return { text: 'Pending', colorClass: 'pending' };
      default:
        return { text: orderDetails.state, colorClass: 'default' };
    }
  };

  const statusInfo = getPaymentStatusInfo();

  return (
    <div className="success_container">
      <div className="success-card">
        <h1>Payment <span className={statusInfo.colorClass}>{statusInfo.text}</span></h1>
        <hr />

        {error && <p className="error">{error}</p>}

        {orderDetails ? (
          <div className="order-details">
            <p><strong>Order ID:</strong> {orderDetails.orderId}</p>
            <p><strong>Status:</strong> {orderDetails.state}</p>
            <p><strong>Amount:</strong> ₹{(orderDetails.amount / 100).toFixed(2)}</p>

            {orderDetails.paymentDetails?.length > 0 && (
              orderDetails.paymentDetails.map((detail, index) => (
                <div key={index} className="payment-attempt">
                  <h4>Attempt {index + 1}</h4>
                  <p><strong>Payment Mode:</strong> {detail.paymentMode}</p>
                  <p><strong>Transaction ID:</strong> {detail.transactionId}</p>
                  <p><strong>Status:</strong> {detail.state}</p>
                  <p><strong>Time:</strong> {new Date(detail.timestamp).toLocaleString()}</p>
                </div>
              ))
            )}
          </div>
        ) : (
          !error && <p>Loading payment details...</p>
        )}
      </div>

      <style>{`
        .success_container {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 50px;
        }

        .success-card {
          background: #fff;
          padding: 40px;
          border-radius: 16px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          text-align: left;
          width: 100%;
          max-width: 600px;
        }

        .success-card h1 {
          text-align: center;
          margin-bottom: 20px;
          font-size: 28px;
          font-weight: 500;
          color: #333;
        }

        .success-card hr {
          margin-bottom: 24px;
          border: none;
          border-top: 1px solid #eaeaea;
        }

        .order-details {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .success-card p {
          font-size: 16px;
          margin: 0;
        }

        .payment-attempt {
          margin-top: 20px;
          padding: 10px;
          background-color: #eef3ff;
          border-left: 5px solid #007bff;
          border-radius: 4px;
        }

        .error {
          color: red;
          font-weight: bold;
        }
        
        .successful {
          color: #10b981;
        }
        
        .failed {
          color: #ef4444;
        }
        
        .pending {
          color: #f59e0b;
        }
        
        .processing {
          color: #6366f1;
        }
        
        .default {
          color: #6b7280;
        }
      `}</style>
    </div>
  );
}